// extracted by mini-css-extract-plugin
module.exports = {"main":"Item_main__2SoC4"};